<template>
  <div class="shop-clinic-products">
    <p class="shop-clinic-products__lead">
      Цены и наличие — со склада клиники. Забронируйте онлайн и заберите в клинике.
    </p>
    <ShopProductGrid :products="stock.data"/>
    <NuxtLink v-if="stock.total > stock.data.length" :to="shopUrl(shopPaths.catalog())" class="shop-clinic-products__more">
      Весь каталог
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import type {ShopClinicProducts} from '~/types/shopStorefront'
const shopPaths = useShopPaths()

defineProps<{
  stock: ShopClinicProducts
}>()

const {shopUrl} = useShopHost()
</script>

<style lang="scss" scoped>
.shop-clinic-products {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__lead {
    margin: 0;
    color: $color-gray;
  }

  &__more {
    align-self: flex-start;
    font-weight: 600;
  }
}
</style>
